export const getCurrentPathname = () => {
  if (typeof location !== 'undefined') {
    if (typeof location.pathname === 'string') {
      return location.pathname;
    } else if (typeof location.href === 'string') {
      return location.href
        .replace(/^[0-9a-z]+:\/\/[^\/]+/, '') // 去掉 origin
        .replace(/\?.*$/, '') // 去掉 querystring
        .replace(/#.*$/, ''); // 去掉 hash
    }
  }
  return '/';
};
